import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "scope-filter" }
const _hoisted_2 = { class: "scope-value" }
const _hoisted_3 = {
  key: 0,
  class: "icon icon-checkmark",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RcDropdownTrigger = _resolveComponent("RcDropdownTrigger")!
  const _component_RcDropdownItem = _resolveComponent("RcDropdownItem")!
  const _component_RcDropdown = _resolveComponent("RcDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RcDropdown, {
      "aria-label": _ctx.label,
      placement: "bottom-start"
    }, {
      dropdownCollection: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createBlock(_component_RcDropdownItem, {
            key: option.value,
            disabled: _ctx.disabled || option.disabled,
            title: option.label,
            class: "scope-option",
            onClick: ($event: any) => (_ctx.select(option))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(option.label), 1),
              _cache[2] || (_cache[2] = _createTextVNode()),
              (option.value === _ctx.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                : _createCommentVNode("", true)
            ]),
            _: 2,
            __: [2]
          }, 1032, ["disabled", "title", "onClick"]))
        }), 128))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_RcDropdownTrigger, {
          class: "scope-trigger",
          variant: "secondary",
          size: "small",
          disabled: _ctx.disabled,
          "aria-label": `${_ctx.label}: ${_ctx.selectedLabel}`,
          title: _ctx.selectedLabel
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.selectedLabel), 1),
            _cache[0] || (_cache[0] = _createTextVNode()),
            _cache[1] || (_cache[1] = _createElementVNode("i", {
              class: "icon icon-chevron-down",
              "aria-hidden": "true"
            }, null, -1))
          ]),
          _: 1,
          __: [0,1]
        }, 8, ["disabled", "aria-label", "title"]),
        _cache[3] || (_cache[3] = _createTextVNode())
      ]),
      _: 1,
      __: [3]
    }, 8, ["aria-label"])
  ]))
}